import React, { Component } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import moment from "moment-timezone";
import NoData from "../Dashboard/Charts/NoData/NoData";
import { numberWithCommas } from "../Dashboard/utils";

class PostCommentsChart extends Component {
    constructor(props) {
        super(props);
        this.chartComponent = React.createRef();
        this.state = {
            rerender: 0,
        };
    }

    componentDidMount() {
        // if (!this.props.isFBPage) {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent?.current?.chart?.setSize(null, null);
                this.chartComponent?.current?.chart?.reflow();
            }, 0);
        });
        if (this.props.widgetContainerRef?.current) {
            this.ro.observe(this.props.widgetContainerRef?.current);
        } else {
            this.setState({ rerender: this.state.rerender + 1 });
        }
        // }
    }

    componentWillUnmount() {
        if (!this.props.isFBPage) {
            this.ro.disconnect();
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.rerender) {
            if (this.props.widgetContainerRef?.current) {
                this.ro.observe(this.props.widgetContainerRef?.current);
                this.setState({ rerender: 0 });
            } else if (prevState.rerender !== this.state.rerender) {
                setTimeout(() => {
                    this.setState({ rerender: this.state.rerender + 1 });
                }, 100);
            }
        }
    }

    // componentDidUpdate(prevProps) {
    //     if (this.props.resizedCount !== prevProps.resizedCount && this.props.data && !this.props.data.nodata) {
    //         this.chartComponent.current?.chart?.setSize(null, null);
    //         this.chartComponent.current?.chart?.reflow();
    //     }
    // }

    getOptions = () => {
        if (this.props.graph_type == "line") return this.getLineOptions();
        else return this.getBarOptions();
    };

    getLineOptions = () => {
        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let tzo = JSON.parse(localStorage.company).user_timezone * -60;

        let x = JSON.parse(JSON.stringify(this.props.data || {}));
        const height = this.props.isFBPage ? "338px" : null;
        const legendAlign = this.props.isFBPage ? "right" : "center";

        let series;
        let self = this;

        series = [{ color: "#53BEA7", name: "Comment", data: x?.comments_agg ? x.comments_agg : [] }];

        const pageViewConfig = {
            plotOptions: {
                series: {
                    cursor: "pointer",
                    stacking: null,
                    marker: {
                        enabled: true,
                        radius: 2,
                    },
                },
            },
            chart: {
                type: "spline",
                className: "skiptranslate",
                // height: 300,
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
                height,
            },
            credits: {
                enabled: false,
            },
            lang: {
                noData: "No Data.",
            },
            legend: {
                enabled: this.props.showLegend,
                alignColumns: false,
                align: legendAlign,
            },
            noData: {
                position: {
                    align: "center",
                },
            },
            title: {
                text: "",
            },
            yAxis: {
                title: "",
                // tickInterval: 10,
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "ShortDash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                min: x?.avg_value < x.min && self.props.showAverage ? x.min - 1 : null,
                max: x?.avg_value > x.min && self.props.showAverage ? x.max + 1 : null,
                allowDecimals: false,
                plotLines: self.props.showAverage
                    ? [
                          {
                              color: "#8e95a4", // Color value
                              value: x?.avg_value, // Value of where the line will appear
                              width: 2, // Width of the line
                              dashStyle: "solid",
                              zIndex: 6,
                              label: {
                                  align: "right",
                                  text: `Average : ${x?.avg_value}`,
                                  style: {
                                      color: "#8e95a4",
                                      fontWeight: "bold",
                                  },
                              },
                          },
                      ]
                    : [],
            },
            xAxis: {
                type: "datetime",
                dateTimeLabelFormats: {
                    millisecond: "%l:%M:%S.%L %p",
                    second: "%l:%M:%S %p",
                    minute: "%l:%M %p",
                    hour: "%l:%M %p",
                    day: "%e %b",
                    week: "%e. %b",
                    month: "%b '%y",
                    year: "%Y",
                },
            },
            tooltip: {
                crosshairs: true,
                backgroundColor: "#fff",
                borderRadius: 6,
                formatter: function () {
                    return `<span>${moment(this.x).tz(tz).format("LLLL")}</span>
                    <br/><span>${this.series.name}: <b>${numberWithCommas(self.props.isAverage ? this.y.toFixed(2) : this.y)}</b></span>`;
                },
            },
            series: series,
            time: {
                // useUTC: false,
                timezoneOffset: tzo,
            },
        };

        return pageViewConfig;
    };

    getBarOptions = () => {
        let x = JSON.parse(JSON.stringify(this.props.data || {}));
        const height = this.props.isFBPage ? "338px" : null;
        const legendAlign = this.props.isFBPage ? "right" : "center";

        let series;
        let self = this;

        series = [{ color: "#53BEA7", name: "Comment", data: x?.comments_agg ? x.comments_agg : [] }];

        const pageViewColumnConfig = {
            //renderTo: 'charts-column',
            plotOptions: {
                series: {
                    cursor: "pointer",
                    stacking: "normal",
                    // pointRange: tick_interval,
                },
            },
            chart: {
                // height: 300,
                type: "column",
                height,
            },
            credits: {
                enabled: false,
            },
            title: {
                text: "",
            },
            yAxis: {
                title: "",
                // tickInterval: 10,
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "ShortDash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                min: x?.avg_value < x.min && self.props.showAverage ? x.min - 1 : null,
                max: x?.avg_value > x.min && self.props.showAverage ? x.max + 1 : null,
                allowDecimals: false,
                plotLines: self.props.showAverage
                    ? [
                          {
                              color: "#8e95a4", // Color value
                              value: x?.avg_value, // Value of where the line will appear
                              width: 2, // Width of the line
                              dashStyle: "solid",
                              zIndex: 6,
                              label: {
                                  align: "right",
                                  text: `Average : ${x?.avg_value}`,
                                  style: {
                                      color: "#8e95a4",
                                      fontWeight: "bold",
                                  },
                              },
                          },
                      ]
                    : [],
            },
            xAxis: {
                type: "datetime",
                dateTimeLabelFormats: {
                    millisecond: "%l:%M:%S.%L %p",
                    second: "%l:%M:%S %p",
                    minute: "%l:%M %p",
                    hour: "%l:%M %p",
                    day: "%e %b",
                    week: "%e. %b",
                    month: "%b '%y",
                    year: "%Y",
                },
            },
            lang: {
                noData: "No Data.",
            },
            tooltip: {
                crosshairs: true,
                backgroundColor: "#fff",
                borderRadius: 6,
                formatter: function () {
                    return `<span>${moment(this.x).format("LLLL")}</span>
                    <br/><span>${this.series.name}: <b>${numberWithCommas(self.props.isAverage ? this.y.toFixed(2) : this.y)}</b></span>`;
                },
            },
            legend: {
                enabled: this.props.showLegend,
                itemStyle: {
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "capitalize ",
                    paddingTop: "10px",
                    color: "#1f2e3d",
                },
                alignColumns: false,
                paddingTop: 18,
                align: legendAlign,
            },
            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "14px",
                    color: "#1f2e3d",
                    fontFamily: "'Roboto', sans-serif",
                },
                position: {
                    align: "center",
                },
            },
            series,
            time: {
                useUTC: false,
            },
        };

        return pageViewColumnConfig;
    };

    render() {
        return (
            <>
                {!this.props.isNoData() ? (
                    <>
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={this.getOptions()}
                            ref={this.chartComponent}
                            containerProps={!this.props.isFBPage && { style: { width: "100%", height: "calc(100% - 35px)" } }}
                        />
                    </>
                ) : (
                    <NoData message={this.props.pageStatus ? "Page is Inactive. Please re-authenticate" : ""} />
                )}
            </>
        );
    }
}

export default PostCommentsChart;
